import { styled } from 'components/ThemeConfigConnector/ThemeConfigConnnector';

export const ContentContainer = styled.main<{ withFooter: boolean }>`
    min-height: ${(props) => (props.withFooter ? 'calc(100vh - 48px)' : 'auto')};
    position: relative;
    background-color: ${(props) => props.theme.brandedConfig.background};
`;
